const screenPrintingFaq = [
  {
    question: "What is screen printing?",
    answer:
      "Screen printing is a printing technique where a design is transferred to a printing surface through a mesh screen. Ink is then pressed through the screen onto the material, creating a vibrant and durable print. It's a popular method for customizing apparel, textiles, and promotional items.",
  },
  {
    question: "What types of materials can be screen printed?",
    answer:
      "Screen printing is versatile and can be applied to various materials, including cotton, polyester, blends, and even specialty fabrics. It's commonly used for T-shirts, hoodies, bags, posters, and other promotional products.",
  },
  {
    question:
      "What is the advantage of screen printing over other printing methods?",
    answer:
      "Screen printing offers several advantages, including vibrant and long-lasting colors, excellent color opacity, and the ability to print on a variety of materials. It's cost-effective for larger quantities, making it a preferred choice for bulk orders and promotional merchandise.",
  },
  {
    question: "How many colors can be used in a screen printing design?",
    answer:
      "The number of colors in a screen printing design depends on the printing process and the equipment used. While some methods allow for a limited number of colors, others, like CMYK process printing, can reproduce a full spectrum of colors for more complex designs.",
  },
  {
    question: "What is the typical turnaround time for screen printing orders?",
    answer:
      "Turnaround times vary based on the complexity of the order, quantity, and current workload. We work closely with our clients to establish realistic timelines and strive to deliver high-quality screen-printed products within agreed-upon deadlines. Contact us for specific timelines related to your project.",
  },
];
export default screenPrintingFaq;
